import React, { useEffect, useState } from "react";
import { use } from "react";
import { Layer, Rect, Circle, Transformer, Text, Line } from "react-konva";
import checkForOverlap from "./overlapCheck.component";
import { sortPointsClockwise } from "./point-sorting.component";

export default function Mask(props) {
    const trRef = React.useRef();
    const shapeRef = React.useRef();
    const [overlapInfo, setOverlapInfo] = useState([]);
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        if (trRef.current && props.selected && props.maskType !== "polygon") {
            trRef.current.nodes([shapeRef.current]);
            trRef.current.getLayer().batchDraw();
        }
    }, [props.selected]);

    const getDynamicFontSize = () => {
        return Math.max(1.5, 18 / props.stageScale);
    };

    const getTextPosition = () => {
        const fontOffset = getDynamicFontSize() + 0.5;

        if (!shapeRef.current) return { x: 0, y: 0 };

        const node = shapeRef.current;
        const nodeX = node.x();
        const nodeY = node.y();
        const scaleX = node.scaleX();
        const scaleY = node.scaleY();
        const radius = props.mask.radius;

        if (props.maskType === "rectangle") {
            return {
                x: nodeX,
                y: nodeY - fontOffset,
            };
        } else if (props.maskType === "circle") {
            return {
                x: nodeX - radius * scaleX,
                y: nodeY - radius * scaleY - fontOffset,
            };
        }
        return { x: 0, y: 0 };
    };

    const handleDragEnd = (e) => {
        props.updateMask(e, props.i, props.maskType);
        setIsDragging(false);
    };

    const handleTransformEnd = (e) => {
        props.updateMask(e, props.i, props.maskType);
    };

    useEffect(() => {
        const overlapInfo = checkForOverlap(props.maskList);
        setOverlapInfo(overlapInfo);
    }, [props.maskList]);

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Rendering
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    return (
        <Layer key={props.i}>
            {props.mask.name && !props.mask.visible && (
                <Text
                    text={props.mask.name}
                    x={getTextPosition().x}
                    y={getTextPosition().y}
                    align="center"
                    fontSize={getDynamicFontSize()}
                    fontStyle="bold"
                    fill="black"
                />
            )}

            {props.maskType === "rectangle" ? (
                <Rect
                    ref={shapeRef}
                    x={props.mask.x}
                    y={props.mask.y}
                    scaleX={props.mask.scaleX}
                    scaleY={props.mask.scaleY}
                    rotation={props.mask.rotation}
                    width={props.mask.width}
                    height={props.mask.height}
                    fill={props.mask.color || "lightblue"}
                    opacity={props.mask.opacity}
                    draggable={props.mask.selected}
                    listening={!props.mask.locked}
                    onTap={() => props.selectMask(props.mask.id)}
                    onClick={() => props.selectMask(props.mask.id)}
                    onDragEnd={handleDragEnd}
                    onDragStart={() => setIsDragging(true)}
                />
            ) : props.maskType === "circle" ? (
                <Circle
                    ref={shapeRef}
                    x={props.mask.x}
                    y={props.mask.y}
                    scaleX={props.mask.scaleX}
                    scaleY={props.mask.scaleY}
                    radius={props.mask.radius}
                    fill={props.mask.color || "lightblue"}
                    draggable={props.mask.selected}
                    listening={!props.mask.locked}
                    opacity={props.mask.opacity}
                    onTap={() => props.selectMask(props.mask.id)}
                    onClick={() => props.selectMask(props.mask.id)}
                    onDragEnd={handleDragEnd}
                    onDragStart={() => setIsDragging(true)}
                />
            ) : null}

            {!isDragging &&
                overlapInfo
                    .filter(
                        (overlap) =>
                            overlap.mask1Id === props.mask.id || overlap.mask2Id === props.mask.id
                    )
                    .map((overlap, index) => {
                        const sortedPoints = sortPointsClockwise(overlap, props.maskList);
                        return sortedPoints.length > 2 ? (
                            <Line
                                key={index}
                                points={sortedPoints.flatMap(p => [p.x, p.y])}
                                fill="black"
                                closed
                                listening={false}
                                globalCompositeOperation="destination-out"
                            />
                        ) : null;
                    })}


            {props.selected && (
                <Transformer ref={trRef} keepRatio={true} onTransformEnd={handleTransformEnd} />
            )}
        </Layer>
    );
}
